import React from 'react';
import ReactDOMServer from "react-dom/server";

const trainingCircle = <div className="new-quote-container centered">
  <div className="splash-icon">⭕</div>
  <div className="splash-header">
    <h1 className="no-word-break">Your Training Circle</h1>
    <div className="quote">
      Your fitness journey is stronger when you share it with the people closest to you – friends, family, or training partners.
    </div>
  </div>
</div>;

const trainingCircleElement = {
  name: 'training-circle',
  type: 'html',
  html: ReactDOMServer.renderToStaticMarkup(trainingCircle),
}

export default trainingCircleElement;
